export default __webpack_public_path__ + "static/media/check-mark.77a4ddb2.svg";